
const NorwegianBankId = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="21"
            viewBox="0 0 33 21"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <g clipPath="url(#clip0_2584_9931)">
                <path
                    d="M7.5 3H1.5C0.7 3 0 2.3 0 1.5C0 0.7 0.7 0 1.5 0H7.5C8.3 0 9 0.7 9 1.5C9 2.3 8.3 3 7.5 3Z"
                    fill="white"
                />
                <path
                    d="M7.5 15H1.5C0.7 15 0 14.3 0 13.5C0 12.7 0.7 12 1.5 12H7.5C8.3 12 9 12.7 9 13.5C9 14.3 8.3 15 7.5 15Z"
                    fill="white"
                />
                <path
                    d="M7.5 21H1.5C0.7 21 0 20.3 0 19.5C0 18.7 0.7 18 1.5 18H7.5C8.3 18 9 18.7 9 19.5C9 20.3 8.3 21 7.5 21Z"
                    fill="white"
                />
                <path
                    d="M19.5 9H13.5C12.7 9 12 8.3 12 7.5C12 6.7 12.7 6 13.5 6H19.5C20.3 6 21 6.7 21 7.5C21 8.3 20.3 9 19.5 9Z"
                    fill="white"
                />
                <path
                    d="M19.5 15H13.5C12.7 15 12 14.3 12 13.5C12 12.7 12.7 12 13.5 12H19.5C20.3 12 21 12.7 21 13.5C21 14.3 20.3 15 19.5 15Z"
                    fill="white"
                />
                <path
                    d="M31.5 3H25.5C24.7 3 24 2.3 24 1.5C24 0.7 24.7 0 25.5 0H31.5C32.3 0 33 0.7 33 1.5C33 2.3 32.3 3 31.5 3Z"
                    fill="white"
                />
                <path
                    d="M31.5 9H25.5C24.7 9 24 8.3 24 7.5C24 6.7 24.7 6 25.5 6H31.5C32.3 6 33 6.7 33 7.5C33 8.3 32.3 9 31.5 9Z"
                    fill="white"
                />
                <path
                    d="M31.5 21H25.5C24.7 21 24 20.3 24 19.5C24 18.7 24.7 18 25.5 18H31.5C32.3 18 33 18.7 33 19.5C33 20.3 32.3 21 31.5 21Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2584_9931">
                    <rect width="33" height="21" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default NorwegianBankId;
